const NavItem = ({ item, isActive, onClick, className = "" }) => {
  const Icon = item.icon;

  const baseClasses =
    "w-full flex items-center space-x-4 p-4 rounded-xl transition-colors duration-200";
  const activeClasses =
    "bg-gradient-to-r from-purple-100 to-blue-100 text-purple-700 shadow-md";
  const inactiveClasses = "hover:bg-gray-50 text-gray-700";

  return (
    <button
      onClick={() => onClick(item)}
      className={`${baseClasses} ${
        isActive ? activeClasses : inactiveClasses
      } ${className}`}
      aria-label={`Navigate to ${item.title}`}
    >
      <div
        className={`p-2 rounded-lg flex-shrink-0 ${
          isActive ? "bg-purple-200" : "bg-gray-100"
        }`}
      >
        <Icon
          className={`w-5 h-5 ${
            isActive ? "text-purple-600" : "text-gray-600"
          }`}
        />
      </div>
      <div className="flex-1 text-left min-w-0">
        <p className="font-medium truncate">{item.title}</p>
      </div>
    </button>
  );
};

export default NavItem;
